import { Component, ElementRef, EventEmitter, Input, Output, ViewChild, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-text-box-freeform',
    templateUrl: './text-box-freeform.component.html',
    styleUrls: ['./text-box-freeform.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class TextBoxFreeformComponent {
  @Input() value: string = '';
  @Input() required: boolean = false;
  @Input() isReadonly: boolean = false;
  @Input() caption: string;
  @Input() errorMessage: string;
  @Input() helpText: string;
  @Input() textAlignCenter: boolean = false;
  @Output() textChange = new EventEmitter<string>();
  @ViewChild('input') input: ElementRef;

  onTextChange(e: Event) {
    this.textChange.emit((e.target as HTMLTextAreaElement).value);
  }

  focus() {
    this.input?.nativeElement?.focus();
  }
}
